import classNames from 'classnames';
import { ReactNode, useMemo } from 'react';
import { useCountdown } from '~/components/Util';
import { T } from '../I18n/Translation';
import styles from './Timer.module.scss';

export type TimerProps = {
  className?: string;
  value: Date;
  prefix?: ReactNode;
};

export const Timer = ({ value, className, prefix }: TimerProps) => {
  const countdown = useCountdown(value);
  const { days, hours, minutes, seconds } = countdown;
  const timeToString = useMemo(
    () =>
      `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`,
    [hours, minutes, seconds]
  );
  const onSaleText = useMemo(() => {
    if (days === 0) {
      return <T name="citizen_home_b2c_onsale_time_in24" options={{ time: timeToString }} />;
    } else if (days === 1) {
      return <T name="citizen_home_b2c_onsale_days_more24" />;
    } else {
      return <T name="citizen_home_b2c_onsale_days_more48" options={{ day: days }} />;
    }
  }, [days, timeToString]);
  return (
    <div className={classNames(styles.root, className)}>
      {prefix && <span className="prefix">{prefix}</span>}
      {onSaleText}
    </div>
  );
};
